var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryStrategy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2399 20.4657C29.4601 19.8267 29.5905 19.0117 29.5905 17.9307C29.5905 12.7504 26.2421 8.83691 21.0614 8.83691C15.8806 8.83691 11.846 12.1191 11.6808 17.2956C11.5108 22.6244 14.8965 22.9155 16.3153 25.7192C17.734 28.523 16.2353 29.93 16.9495 31.2569C17.3087 31.9242 19.9441 32.2182 21.8691 32.0193",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4989 24.9022L8.47435 27.8922",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5184 5.96487L29.4939 8.95494",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65007 5.96487L11.6746 8.95494",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9338 11.7654C21.2153 11.6133 22.1238 11.6133 22.6591 11.7654C23.1945 11.9174 23.835 12.3573 24.5805 13.0851",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5087 15.1444C26.7555 15.6417 26.9039 16.0168 26.9539 16.2696C27.0039 16.5225 27.0039 16.8975 26.9539 17.3948",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 2V6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17H9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17H37",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.931 40.5263H23.4391",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6653 37.7723H22.6086",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6653 35.0182H22.4233",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2688 21.8726C27.4354 21.5261 27.7857 21.3058 28.1701 21.3058H35.5516C35.943 21.3058 36.2985 21.5342 36.4611 21.8902L36.87 22.7851L37.7573 23.1401C38.137 23.2919 38.3859 23.6596 38.3859 24.0685V39.6814C38.3859 40.0903 38.137 40.458 37.7573 40.6099L36.8961 40.9543L36.5516 41.8155C36.3998 42.1952 36.0321 42.4441 35.6232 42.4441H28.0686C27.6597 42.4441 27.2919 42.1952 27.1401 41.8155L26.7829 40.9225L25.8806 40.4986C25.5298 40.3337 25.3058 39.9811 25.3058 39.5935V24.1191C25.3058 23.7226 25.5401 23.3636 25.9029 23.2039L26.8238 22.7985L27.2688 21.8726ZM28.799 23.3058L28.4662 23.9981C28.3629 24.2131 28.1861 24.384 27.9678 24.4801L27.3058 24.7715V27.8531H29.5795C29.6612 27.8531 29.7427 27.8631 29.822 27.883L33.7317 28.8604H36.3859V24.7456L35.7554 24.4934C35.5168 24.3979 35.3241 24.2142 35.2172 23.9804L34.909 23.3058H28.799ZM27.3058 32.3859V29.8531H29.4564L33.3661 30.8305C33.4454 30.8504 33.5268 30.8604 33.6086 30.8604H36.3859V33.3932H33.7317L29.822 32.4157C29.7427 32.3959 29.6612 32.3859 29.5795 32.3859H27.3058ZM27.3058 34.3859V38.9584L27.9901 39.2799C28.2194 39.3877 28.3993 39.5784 28.4934 39.8136L28.7456 40.4441H34.9461L35.1983 39.8136C35.3 39.5595 35.5013 39.3582 35.7554 39.2566L36.3859 39.0044V35.3932H33.6086C33.5268 35.3932 33.4454 35.3831 33.3661 35.3633L29.4564 34.3859H27.3058Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryStrategy);
export default __webpack_public_path__ + "static/media/category-strategy.57646e451f89e5bbf09b88b470bce038.svg";
export { ForwardRef as ReactComponent };